export const APPCONFIG = {
  GATEWAY_ENDPOINT: process.env.REACT_APP_GATEWAY_ENDPOINT,
};
